import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionEmailEditorComponent from './ActionEmailEditorComponent';

class ActionEmailEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionEmailEditorComponent />} type='email' icon='found-mail' />;
  }
}

export default ActionEmailEditorContainer;
